document.addEventListener("submit", (e) => {
  const form = e.target;
  if (!form || !form.classList.contains("shopify-product-form")) return;

  // only apply for our luxury card buttons
  const btn = form.querySelector(".lux-btn");
  if (!btn) return;

  // If already loading, block
  if (btn.classList.contains("is-loading")) {
    e.preventDefault();
    return;
  }

  const spinner = btn.querySelector(".loading-overlay__spinner");
  btn.classList.add("is-loading");
  btn.setAttribute("aria-busy", "true");
  btn.disabled = true;
  if (spinner) spinner.classList.remove("hidden");

  // Fallback: if theme does full page submit or no AJAX, re-enable after a short time
  // (AJAX themes will usually update sections and we catch that below.)
  window.setTimeout(() => {
    // If still loading after 6s, release to avoid stuck UI
    if (btn.classList.contains("is-loading")) {
      btn.classList.remove("is-loading");
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
      if (spinner) spinner.classList.add("hidden");
    }
  }, 6000);
}, true);

/**
 * Many Shopify themes dispatch cart events after AJAX add.
 * We'll listen for common ones and stop loader.
 */
function stopLuxLoader() {
  document.querySelectorAll(".lux-btn.is-loading").forEach((btn) => {
    const spinner = btn.querySelector(".loading-overlay__spinner");
    btn.classList.remove("is-loading");
    btn.removeAttribute("aria-busy");
    btn.disabled = false;
    if (spinner) spinner.classList.add("hidden");
  });
}

// Common theme events (some themes fire these)
document.addEventListener("cart:updated", stopLuxLoader);
document.addEventListener("cart:refresh", stopLuxLoader);
document.addEventListener("ajaxProduct:added", stopLuxLoader);

// Dawn-style: when sections re-render, stop loader
document.addEventListener("shopify:section:load", stopLuxLoader);

// As a last resort, stop loader on any fetch completion to /cart/add
(function () {
  const _fetch = window.fetch;
  if (!_fetch) return;

  window.fetch = function () {
    return _fetch.apply(this, arguments).then((res) => {
      try {
        const url = arguments[0]?.url || arguments[0];
        if (typeof url === "string" && url.includes("/cart/add")) {
          // wait a tick for DOM updates
          setTimeout(stopLuxLoader, 250);
        }
      } catch (err) {}
      return res;
    });
  };
})();